import { render, staticRenderFns } from "./AddEditDeliveryModal.vue?vue&type=template&id=4a2b5e6b&scoped=true"
import script from "./AddEditDeliveryModal.vue?vue&type=script&lang=js"
export * from "./AddEditDeliveryModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditDeliveryModal.vue?vue&type=style&index=0&id=4a2b5e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b5e6b",
  null
  
)

export default component.exports